module.exports = __webpack_public_path__ + "img/3d-metaverse.50035956.webp";